var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-license-lock" }, [
    _c("div", { staticClass: "error-license-lock__header" }, [
      _c(
        "div",
        { staticClass: "error-license-lock__header-logo" },
        [_c("CompassLogo", { attrs: { type: "logo", width: 160 } })],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "error-license-lock__container" },
      [
        _vm.isDisplayed
          ? [
              _c("div", { staticClass: "error-license-lock__illustration" }, [
                _c("img", {
                  attrs: {
                    src: "/ressources/logged/img/errors/lock.svg",
                    width: 210,
                    height: 160
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "error-license-lock__content" }, [
                _c(
                  "h1",
                  {
                    staticClass:
                      "error-license-lock__title typographies-display-large"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "error-license-lock__subtitle typographies-paragraph-x-large-regular"
                  },
                  _vm._l(_vm.subtitles, function(subtitle, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(subtitle) +
                          "\n                        "
                      ),
                      index < _vm.subtitles.length - 1 ? _c("br") : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }